/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".errors-container[_ngcontent-%COMP%]{text-align:center;width:100%;padding:0 0 15px}.errors-list[_ngcontent-%COMP%]{margin:0;padding:0;display:inline;border-bottom:1px solid red}.errors-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline}.errors-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]::after{content:', '}.errors-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child::after{content:'.'}"];
export { styles as styles };
